import installer from './defaults'
export * from '@code-monkey-ui/components'
export * from '@code-monkey-ui/components/dshIndex'
export * from '@code-monkey-ui/constants'
export * from '@code-monkey-ui/directives'
export * from '@code-monkey-ui/hooks'
export * from './make-installer'

export const install = installer.install
export const version = installer.version
export default installer

export { default as dayjs } from 'dayjs'
